export default "__VITE_ASSET__pSB9BWjj__"